import React from 'react';
import { Container, Row, Col, Button, } from 'react-bootstrap';
import { FaPhoneVolume } from "react-icons/fa6";
import { MdLocationOn, MdOutlineEmail } from "react-icons/md";
import { BiLogoFacebookCircle } from "react-icons/bi";
import Imgxing from '../../assets/xingImg.png'
import Imglinkidin from '../../assets/Linkdin.png'
import Imgyoutube from '../../assets/youtube.png'
import Imgkaggle from '../../assets/kaggleImg.png'
import Imgfacebook from '../../assets/Facebook.png'
import { Link } from 'react-router-dom';
import './HfFooter.css'
import { useTranslation } from 'react-i18next';
import ContactForm from '../ContactForm/ContactForm';

import imgHANSA_FLEX_SPAIN_Catalog from '../../assets/HANSA_FLEX_SPAIN_Catalog.png'

import accessibility from '../../assets/policy/Accessibility-Policy-HFC.pdf';
import { getLocalizedSlug } from '../../lib/slugs';

const HfFooter = () => {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language || 'en').substring(0, 2);

  return (
    <footer className='hfFooter-wrapper mt-5' id='contact-us-section'>
      <Container className='hfFooter-container'>
        <Row className="justify-content-center " style={{ marginLeft: 'auto' }}>
          <Col sm={12} lg={4} >
            <div className='footer-column-div'>
              <b>{(t('HANSA-FLEX Catalog'))}</b>
              <ul>
                <li><a href="Connection_technology_catalogue_EN_web.pdf" target="_blank" rel="noopener noreferrer" className="footer-link"><img src={imgHANSA_FLEX_SPAIN_Catalog} alt="HANSA_FLEX_SPAIN_Catalog_Book_Cover" width="50%" /></a></li>
                <li><a href="Connection_technology_catalogue_EN_web.pdf" target="_blank" rel="noopener noreferrer" className="footer-link"> {t("HANSA-FLEX IBÉRICA  corporate catalog")} </a></li>
              </ul>
              <br />
            </div>
            <div className='footer-column-div'>
              <b>{(t("Follow us on social media"))}</b>
              <ul className='footer-social-media-ul'>
                <div className="circle-col"><a href="https://www.linkedin.com/company/hansa-flex-iberica/" target="_blank" rel="noopener noreferrer"><div><img src={Imglinkidin} alt="" /></div></a></div>
                <div className="circle-col"><a href="https://www.youtube.com/@HANSAFLEXIB%C3%89RICA" target="_blank" rel="noopener noreferrer"><div><img src={Imgyoutube} alt="" /></div></a></div>
                {/* <div className="circle-col"><a href="https://www.linkedin.com/company/hansa-flex-chile-s.a./" target="_blank" rel="noopener noreferrer"><div><img src={Imgfacebook} alt="" /></div></a></div> */}
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={4}>
            <div className='footer-column-div'>
              <b>{(t('Information'))}</b>
              <ul>
                <p>{t("At HANSA-FLEX IBÉRICA , we manufacture ready-to-install hydraulic and pneumatic piping systems, custom-made, with hydraulic components that are tailored to each other and a tailored logistics service.")}</p>
                <p>{t("We are a leading manufacturer of customized solutions using precision technology and offer comprehensive service programs, project planning, engineering, and modern logistics solutions.")} </p>
                <a href={`/${lang}${getLocalizedSlug('contact_us', lang)}`}><button className="submit-button">{t('SEE PHONE')}</button></a>
              </ul>

              <b>{(t('Featured'))}</b>
              <ul>
                <li><a href="https://shop.hansa-flex.es/es_ES/" target="_blank" rel="noopener noreferrer" className="footer-link">{(t('Products'))}</a></li>
                <a href="https://my.hansa-flex.es/es_ES/login" target="_blank" rel="noopener noreferrer" className="footer-link">{(t('X-CODE Manager'))}</a>
                <li><a href="https://shop.hansa-flex.es/componentes-hidr%C3%A1ulicos/c/webcat_HF_HKO" target="_blank" rel="noopener noreferrer" className="footer-link">{(t('Hydraulic Solutions'))}</a></li>
                <li><a href="/certificates" className="footer-link">{(t('Certificates'))}</a></li>
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={4}>
            <div className='footer-column-div'>
            <b>{(t('Send us your query'))}</b>
              <ContactForm />
            </div>
          </Col>
        </Row>

        <div className='HfFooter-link-div'>
          <a className="hf-footer-link" href="">© {(t('Copyright All Rights Reserved'))}</a><span>  |  </span>
          {/* <Link to="/hansa-flex-spain-legal-notice" className="footer-link">{(t('Legal Notice'))}</Link><span>  |  </span> */}
          {/* <Link to="/hansa-flex-spain-privacy-policy" className="footer-link">{(t('Privacy Policy'))}</Link><span>  |  </span> */}
          <Link to={`/${lang}${getLocalizedSlug('terms_and_conditions', lang)}`} className="footer-link">{(t('Terms and Conditions'))}</Link><span>  |  </span>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              document.cookie = "HFCookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              window.location.reload();
            }}
            className="footer-link"          >
            {t('Manage Cookie Preferences')}
          </a>
        </div>
      </Container>
    </footer >

  );
};

export default HfFooter;
